import { CaseStatusFilter } from '@/interfaces';

export const END_STATUSES_CASE: CaseStatusFilter[] = [
	'Aborted',
	'Declined',
	'Case Unsuccessful',
	'Settlement Declined',
	'Cancelled',
	'Closed Case',
	'Case Aborted',
	'Opt Out Request Declined',
];

export const HIDE_PIN_STATUSES_CASE = [...END_STATUSES_CASE, 'Resolved Case'];

export const CLOSED_STATUSES_CASE = [...END_STATUSES_CASE, 'Resolved Case'];

// Statuses eligible for archiving (CLAIM-3465): Resolved Case, Case Aborted
// or Case Unsuccessful (backend status ids 5, 13 and 10 respectively).
export const ARCHIVABLE_STATUSES_CASE: CaseStatusFilter[] = [
	'Case Aborted',
	'Aborted',
	'Case Resolved',
	'Resolved Case',
	'Case Unsuccessful',
];

export const isTerminalCaseStatus = (status: CaseStatusFilter) =>
	ARCHIVABLE_STATUSES_CASE.includes(status);
